export default __webpack_public_path__ + "static/media/holycross.37511303.jpg";